import { API_BASE, getApiHeaders } from './apiClient';

export interface TimelineEvent {
  id:         number;
  eventType:  string;
  actor:      string | null;
  payload:    any;
  occurredAt: string;
}

async function apiFetch<T>(url: string): Promise<T> {
  const res  = await fetch(url, { headers: getApiHeaders() });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data as T;
}

export async function listTimeline(incidentId: string): Promise<TimelineEvent[]> {
  const d = await apiFetch<{ events: TimelineEvent[] }>(`${API_BASE}/cima/incidents/${incidentId}/timeline`);
  return d.events;
}
